var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeRotate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 213,
    viewBox: "0 0 262 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.2414 111.34L27.5889 46.8167L101.294 45.431L101.285 44.9348L101.294 45.431C139.893 44.7031 179.418 67.523 198.096 101.32L233.749 165.843L160.044 167.229L160.053 167.729L160.043 167.229C121.444 167.957 81.9106 145.132 63.2414 111.34L62.8038 111.582L63.2414 111.34Z",
    fill: "#C8CEFF",
    stroke: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.631 102.556C160.72 115.537 153.669 127.75 139.883 129.833C126.096 131.916 110.795 123.082 105.706 110.101C100.617 97.1198 107.667 84.9077 121.454 82.8244C135.24 80.7411 150.542 89.5754 155.631 102.556Z",
    fill: "#CB6030",
    stroke: "#282828"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 107,
    fill: "white",
    transform: "translate(53.5) rotate(30)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeRotate);
export default __webpack_public_path__ + "static/media/eye-rotate.a99e6d4f16b448ce5cd3e6c16d618fe7.svg";
export { ForwardRef as ReactComponent };